module.exports = __webpack_public_path__ + "static/media/details-naslovna.e37a2389.jpg";